import { DeferNonPrimaryContentWrapper } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/DeferNonPrimaryContentWrapper";
import { useSDUIFilterablePaginatedSectionState } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/useSDUIFilterablePaginatedSectionState";
import { usePrefetchRSCPayloadForNextPage } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Pagination/usePrefetchRSCPayloadForNextPage";
import { NoSSR } from "@faire/web/common/NoSSR";
import { useIntersectionObserver } from "@faire/web/ui/hooks/useIntersectionObserver";
import { Suspense } from "react";

/**
 * Defer the prefetching of the next page until the critical components are rendered.
 * This replicates the behavior of the legacy search page.
 */
export const DeferredSDUIFilterablePaginatedSectionNextPagePrefetcherRSC = ({
  handlePaginationLink,
}: {
  handlePaginationLink: (pageNumber: number) => string;
}) => {
  return (
    <NoSSR>
      <Suspense>
        <DeferNonPrimaryContentWrapper>
          <SDUIFilterablePaginatedSectionNextPagePrefetcherRSC
            handlePaginationLink={handlePaginationLink}
          />
        </DeferNonPrimaryContentWrapper>
      </Suspense>
    </NoSSR>
  );
};

/**
 * Prefetch next page for RSC. This replicates the behavior of the legacy search page.
 */
const SDUIFilterablePaginatedSectionNextPagePrefetcherRSC = ({
  handlePaginationLink,
}: {
  handlePaginationLink: (pageNumber: number) => string;
}) => {
  const { oneIndexedPageNumber } = useSDUIFilterablePaginatedSectionState(true);
  const nextPageNumber = oneIndexedPageNumber + 1;

  const nextPageLink = handlePaginationLink(nextPageNumber);
  const prefetchRSCPayloadForNextPage =
    usePrefetchRSCPayloadForNextPage(nextPageLink);

  const ref = useIntersectionObserver(() => {
    prefetchRSCPayloadForNextPage();
  });

  return <div ref={ref} />;
};
